import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LinkUpPrintDialogComponent } from '@app/features/link-up/link-up-print-dialog/link-up-print-dialog.component';
import { SharedModule } from '@app/sharedModule/shared.module';
import { StorybookModule } from '@app/storybook/storybook.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { CookieService } from 'ngx-cookie-service';
import { AutomationRulesFeatureModule } from '../features/automation-rules/automation-rules.module';
import { IntegrationsAuthComponent } from './integrations-auth/integrations-auth.component';
import { AllWorkstationsDevicesOptions } from './link-up/link-up-print-dialog/pipes/link-up.pipes';
import { ReturnModule } from './return/return.module';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    StorybookModule,
    NgxDatatableModule,
    AutomationRulesFeatureModule,
    ReturnModule,
  ],
  declarations: [IntegrationsAuthComponent, LinkUpPrintDialogComponent, AllWorkstationsDevicesOptions],
  exports: [IntegrationsAuthComponent],
  providers: [CookieService],
})
export class FeaturesModule {}
